/* eslint-disable */
import { DeleteOutlined } from "@ant-design/icons";
import { Grid, List, Select, InputNumber, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useStore } from "../../root-store-context";
import { UserWeeklyLogItem } from "../../stores/appStores/user-weekly-log-store";
import { LOCKED_WEEK_MSG } from "../../constants/catMessages";

const { useBreakpoint } = Grid;

export const CAT_COL_WIDTHS = { percent: 90, hours: 110, label: 20, deleteBtn: 24 };

export const CommunitySearchList = observer(() => {

    const { userWeeklyLogStore: { isLoading, UserWeeklyLogItems, CommunityList, isEditHours, isOutsideEditingWindow, deleteSearchCommunityInput, changeTimeAllocatorHRS, changeTimeAllocatorPercent, changeCommunityFromSelect } } = useStore()

    const screens = useBreakpoint();
    const isMobile = !screens.xl;

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().indexOf(input.toLowerCase()) !== -1;

    const selectOptions = Array.isArray(CommunityList) ? CommunityList : [];

    const renderListItem = (item: UserWeeklyLogItem) => {
        return (
            <List.Item style={{ padding: 0, border: "none" }}>
                {isMobile ? (
                    <div className="cat-mobile-community-item">
                        <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                            <Select
                                style={{ width: "100%" }}
                                size="large"
                                showSearch
                                disabled={isOutsideEditingWindow}
                                value={item.UserWeeklyLog.entityId != "0" ? item.UserWeeklyLog.entityId : null}
                                placeholder="Start typing community name or select..."
                                onChange={(e) => changeCommunityFromSelect(e, item.Key)}
                                filterOption={filterOption}
                                status={item.isSelectError ? "error" : ""}
                                options={selectOptions}
                            />
                        </Tooltip>
                        <div className="cat-mobile-inputs-grid">
                            <div className="cat-mobile-inputs-grid__field">
                                <label>Percentage</label>
                                <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                                    <InputNumber<string>
                                        size="large"
                                        min="0.1" max="100" step="0.1"
                                        disabled={isEditHours || isOutsideEditingWindow}
                                        status={item.isPercentLoggedError ? "error" : ""}
                                        value={item.UserWeeklyLog.percentLogged.toString()}
                                        formatter={(value) => `${value}`}
                                        onChange={(e) => changeTimeAllocatorPercent(e, item.Key)}
                                        stringMode />
                                </Tooltip>
                            </div>
                            <span className="cat-mobile-inputs-grid__symbol">%</span>
                            <div className="cat-mobile-inputs-grid__field">
                                <label>Hours</label>
                                <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                                    <InputNumber<string>
                                        size="large"
                                        min="0.1" max="500" step="0.1"
                                        disabled={!isEditHours || isOutsideEditingWindow}
                                        status={item.isHoursLoggedError ? "error" : ""}
                                        value={item.UserWeeklyLog.hoursLogged.toString()}
                                        formatter={(value) => `${value}`}
                                        onChange={(e) => changeTimeAllocatorHRS(e, item.Key)}
                                        stringMode />
                                </Tooltip>
                            </div>
                            <span className="cat-mobile-inputs-grid__symbol">hrs</span>
                            <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                                <DeleteOutlined
                                    className="cat-mobile-inputs-grid__delete"
                                    style={isOutsideEditingWindow ? { opacity: 0.4, cursor: "not-allowed" } : undefined}
                                    onClick={() => { if (!isOutsideEditingWindow) deleteSearchCommunityInput(item.Key); }} />
                            </Tooltip>
                        </div>
                    </div>
                ) : (
                    <div data-testid={`cat-row-community-${item.Key}`} style={{ display: "flex", alignItems: "center", width: "100%", gap: 8, padding: "4px 0" }}>
                        <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                            <Select
                                data-testid={`cat-select-community-${item.Key}`}
                                style={{ flex: 1, minWidth: 0 }}
                                size="middle"
                                showSearch
                                disabled={isOutsideEditingWindow}
                                value={item.UserWeeklyLog.entityId != "0" ? item.UserWeeklyLog.entityId : null}
                                placeholder="Start typing community name or entity number ..."
                                onChange={(e) => changeCommunityFromSelect(e, item.Key)}
                                filterOption={filterOption}
                                status={item.isSelectError ? "error" : ""}
                                options={selectOptions}
                            />
                        </Tooltip>
                        <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                            <InputNumber<string>
                                id={`cat-input-community-percent-${item.Key}`}
                                data-testid={`cat-input-community-percent-${item.Key}`}
                                size="middle"
                                min="0.1" max="100" step="0.1"
                                style={{ width: CAT_COL_WIDTHS.percent, flexShrink: 0 }}
                                disabled={isEditHours || isOutsideEditingWindow}
                                status={item.isPercentLoggedError ? "error" : ""}
                                value={item.UserWeeklyLog.percentLogged.toString()}
                                formatter={(value) => `${value}`}
                                onChange={(e) => changeTimeAllocatorPercent(e, item.Key)}
                                stringMode />
                        </Tooltip>
                        <span className="cat-content__row-label">%</span>
                        <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                            <InputNumber<string>
                                id={`cat-input-community-hours-${item.Key}`}
                                data-testid={`cat-input-community-hours-${item.Key}`}
                                size="middle"
                                min="0.1" max="500" step="0.1"
                                style={{ width: CAT_COL_WIDTHS.hours, flexShrink: 0 }}
                                disabled={!isEditHours || isOutsideEditingWindow}
                                status={item.isHoursLoggedError ? "error" : ""}
                                value={item.UserWeeklyLog.hoursLogged.toString()}
                                formatter={(value) => `${value}`}
                                onChange={(e) => changeTimeAllocatorHRS(e, item.Key)}
                                stringMode />
                        </Tooltip>
                        <span className="cat-content__row-label">hrs</span>
                        <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                            <DeleteOutlined
                                data-testid={`cat-btn-community-delete-${item.Key}`}
                                style={{ width: CAT_COL_WIDTHS.deleteBtn, textAlign: "center", flexShrink: 0, fontSize: 15, ...(isOutsideEditingWindow ? { opacity: 0.4, cursor: "not-allowed" } : { cursor: "pointer", color: "#999" }) }}
                                onClick={() => { if (!isOutsideEditingWindow) deleteSearchCommunityInput(item.Key); }} />
                        </Tooltip>
                    </div>
                )}
            </List.Item>
        );
    };

    const safeItems = Array.isArray(UserWeeklyLogItems) ? UserWeeklyLogItems : [];
    const listData = safeItems.filter(_ => !_.UserWeeklyLog.isDeleted);

    if ((listData.length > 0) || (listData.length === 0 && isLoading)) {
        return (
            <List
                size="small"
                dataSource={listData}
                loading={isLoading}
                renderItem={(item) => renderListItem(item)}
            />
        );
    }

    return <div />;
});